const UUID_KEY = 'SHANJU_DC_STAT_UUID'

function createClientUniqueId() {
  return `${Date.now()}${Math.floor(Math.random() * 1e7)}`
}

export function getClientUniqueId(): string {
  if (typeof window === 'undefined') {
    return createClientUniqueId()
  }

  const storage = window.localStorage
  let id = storage.getItem(UUID_KEY)

  if (!id) {
    id = createClientUniqueId()
    storage.setItem(UUID_KEY, id)
  }

  return id
}

export const UUID: string = getClientUniqueId()

export const USER_KEY = 'mh_user'
